import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createVuetify } from 'vuetify';
import VAnimateCss from 'v-animate-css';
import VCalendar from 'v-calendar';
import 'v-calendar/style.css';



import App from './App.vue';

import 'vuetify/styles';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

const pinia = createPinia();
const vuetify = createVuetify({
  components,
  directives,
});
const app = createApp(App);

app.use(pinia);
app.use(vuetify);
app.use(VAnimateCss);

// Use plugin with optional defaults
app.use(VCalendar, {})
app.mount('#app');

export function mountApp(container) {
  app.mount(container);
}

export default app;
